import { render, staticRenderFns } from "./OfferInfo.vue?vue&type=template&id=2b7b8db6&scoped=true"
import script from "./OfferInfo.vue?vue&type=script&lang=ts"
export * from "./OfferInfo.vue?vue&type=script&lang=ts"
import style0 from "./OfferInfo.vue?vue&type=style&index=0&id=2b7b8db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b8db6",
  null
  
)

export default component.exports